import { SVGInterface } from "../../interface";

const Park = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M16.9498 12H18.9498L11.9498 2L4.9998 12H6.9498L3.0498 18H9.96981V22H13.9198V18H20.9498L16.9498 12ZM6.7398 16L10.6398 10H8.8298L11.9598 5.5L15.1098 10H13.2098L17.2098 16H6.7398Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Park;
